export default __webpack_public_path__ + "static/media/movy-es-frontend.06509900.png";